var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 462 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m397.35 132.52-109.59-109.59a9.61 9.61 0 0 0 -7.07-2.93h-179a40 40 0 0 0 -40 40v342a40 40 0 0 0 40 40h258.59a40 40 0 0 0 40-40v-262.41a10.07 10.07 0 0 0 -2.93-7.07zm-31.21-2.93h-60.45a15 15 0 0 1 -15-15v-60.45zm-5.86 292.41h-258.56a20 20 0 0 1 -20-20v-342a20 20 0 0 1 20-20h169v74.59a35 35 0 0 0 35 35h74.59v252.41a20 20 0 0 1 -20.03 20z",
    fill: "#1E1F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m190.83 174a40.5 40.5 0 1 0 -40.5-40.5 40.55 40.55 0 0 0 40.5 40.5zm0-61a20.5 20.5 0 1 1 -20.5 20.5 20.53 20.53 0 0 1 20.5-20.5z",
    fill: "#1E1F26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m132.22 251.5a10 10 0 0 0 10-10v-6.1a37.11 37.11 0 0 1 37.06-37.06h23.1a37.11 37.11 0 0 1 37.06 37.06v6.1a10 10 0 0 0 20 0v-6.1a57.13 57.13 0 0 0 -57.06-57.06h-23.1a57.13 57.13 0 0 0 -57.06 57.06v6.1a10 10 0 0 0 10 10z",
    fill: "#1E1F26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m126.65 324.67h121.35a10 10 0 0 0 0-20h-121.35a10 10 0 1 0 0 20z",
    fill: "#1E1F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m316.65 357.33h-190a10 10 0 1 0 0 20h190a10 10 0 0 0 0-20z",
    fill: "#1E1F26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvLogo);
export default __webpack_public_path__ + "static/media/CV-logo.47dde9d231a9ea2f4b81ca335aa5b8b7.svg";
export { ForwardRef as ReactComponent };